<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>vip配置</span>
        </div>

        <el-form :inline="true" class="demo-form-inline">
          <el-row v-for="(item, index) in formData" :key="index">
            <el-form-item label="vip等级">
              <el-input v-model.number="item.lv" style="width: 80px;" placeholder="vip等级" />
            </el-form-item>
            <el-form-item label="vip积分">
              <el-input v-model.number="item.numMax" style="width: 80px;" placeholder="vip积分" />
            </el-form-item>
            <el-form-item label="任务奖励倍率">
              <el-input v-model.number="item.taskRewardBet" style="width: 80px;" placeholder="任务奖励倍率" />
            </el-form-item>
            <el-form-item label="体力恢复增量">
              <el-input v-model.number="item.spinsRestore" style="width: 80px;" placeholder="体力恢复增量" />
            </el-form-item>
            <el-form-item label="头像框">
              <el-select v-model="item.avatarBox" style="width: 110px;" placeholder="请选择">
                <el-option
                  v-for="item in avatarBoxArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="盾牌槽增量">
              <el-input v-model.number="item.shieldGroove" style="width: 80px;" placeholder="盾牌槽增量" />
            </el-form-item>
            <el-form-item label="商店体力增量">
              <el-input v-model.number="item.shopAppend" style="width: 80px;" placeholder="商店体力增量" />
            </el-form-item>
            <el-form-item label="打成功金币增加%">
              <el-input v-model.number="item.attackCoinsPro" style="width: 80px;" placeholder="打成功金币增加" />
            </el-form-item>
            <el-form-item label="偷钱金币增加%">
              <el-input v-model.number="item.stealCoinsPro" style="width: 80px;" placeholder="偷钱金币增加" />
            </el-form-item>
            <el-form-item label="嘲讽图">
              <el-select v-model="item.avatarBox" placeholder="请选择">
                <el-option
                  v-for="item in mockArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button v-permisaction="['config:upLimit:del']" type="danger" @click="del(index)">删除</el-button>
            </el-form-item>
          </el-row>
          <el-form-item>
            <el-button v-permisaction="['config:upLimit:add']" type="primary" @click="add()">+</el-button>
          </el-form-item>
          <el-button v-permisaction="['config:upLimit:add']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'
export default {
  name: 'CardNumCoefficientConfig',
  data() {
    return {
      formData: [
        {
          'lv': 0,
          'integration': 0,
          'signInBet': 0,
          'taskRewardBet': 0,
          'spinsRestore': 0,
          'avatarBox': 0,
          'shieldGroove': 0,
          'turnTable': 0,
          'shopAppend': 0,
          'weekRewardSpins': 0,
          'weekRewardShield': 0,
          'weekRewardChest': 0,
          'weekRewardBless': 0,
          'weekRewardLuckydraw': 0,
          'dayVipPoint': 0,
          'attackCoinsPro': 0,
          'stealCoinsPro': 0,
          'attackCss': 0,
          'miningGame': 0,
          'mock': 0,
          'oneClick': 0,
          'richkingStyle': 0
        }
      ],
      avatarBoxArr: [
        { label: '初级头像框', value: 1 },
        { label: '中级头像框', value: 2 },
        { label: '高级头像框', value: 3 },
        { label: '至尊头像框', value: 4 },
        { label: 'XX头像框', value: 5 }
      ],
      mockArr: [
        { label: '无', value: 0 },
        { label: '嘲讽图<1>', value: 1 },
        { label: '嘲讽图<2>', value: 2 },
        { label: '嘲讽图<3>', value: 3 },
        { label: '嘲讽图<4>', value: 4 },
        { label: '嘲讽图<5>', value: 5 }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      for (const i in this.formData) {
        const tempDae = this.formData[i]
        this.formData[i].coefficient = parseFloat(tempDae.coefficient)
      }
      const data = JSON.stringify(this.formData)
      if (data.length < 1) {
        this.msgError('没有需要提交的数据')
      }
      updateCommonCfg({ name: 'CARD_NUM_COEFFICIENT', data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getCommonCfg({ name: 'CARD_NUM_COEFFICIENT' }).then(res => {
        if (res.code === 200) {
          this.formData = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.formData.push({
        'numMin': 0,
        'numMax': 0,
        'coefficient': 0
      })
    },
    del(index) {
      this.formData = this.formData.filter((item, key) => {
        return key !== index
      })
    }
  }
}
</script>

<style scoped>
</style>
